module.exports = __webpack_public_path__ + "static/img/5.a873b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/5.png
// module id = X0cr
// module chunks = 84